import identity from 'lodash/fp/identity';
import { select, type Effect, put } from 'redux-saga/effects';
import type { State } from '@atlassian/jira-portfolio-3-portfolio/src/app-simple-plans/state/types.tsx';
import { update as updateSequence } from '@atlassian/jira-portfolio-3-portfolio/src/app-simple-plans/state/domain/sequence/actions.tsx';
import {
	FAIL_COMMIT_REQUEST,
	type CommitResponseAction,
	type FailCommitRequestAction,
} from '../../issue/types.tsx';
import { json } from '../../http/index.tsx';
import { urls } from '../../issue/api.tsx';
import { POST } from '../../api.tsx';
import { commitBody } from '../../commit/api.tsx';
import { isHandleCommitResponseMethod, handleCommitResponse } from './handleCommitResponse.tsx';

export function* doCommitRequest(
	issueId: string,
	notifyWatchers?: boolean,
	generatedItemId?: string, // eslint-disable-next-line @typescript-eslint/no-explicit-any
): Generator<Effect, CommitResponseAction | FailCommitRequestAction, any> {
	const {
		domain: {
			plan: { id: planId, currentScenarioId },
			sequence,
		},
	}: State = yield select(identity);

	const body = commitBody(
		{ id: planId, currentScenarioId },
		sequence,
		issueId,
		generatedItemId,
		notifyWatchers,
	);

	// eslint-disable-next-line @typescript-eslint/no-explicit-any
	const response: any = yield* json({
		url: urls.commitChanges,
		profile: urls.commitChanges,
		method: POST,
		body,
	});
	if (response.ok) {
		const {
			// eslint-disable-next-line @typescript-eslint/no-shadow
			change: { sequence },
			error,
			entity = {},
			id,
		} = response.data;

		yield put(updateSequence(sequence));

		if (isHandleCommitResponseMethod(handleCommitResponse)) {
			const finalAction = handleCommitResponse({
				change: { sequence },
				error,
				entity,
				id,
			});

			yield put(finalAction);

			return finalAction;
		}
	}

	return { type: FAIL_COMMIT_REQUEST, payload: response };
}
